module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00085-fs8.474c7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00085-fs8.png
// module id = 238
// module chunks = 0